/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sanction_Sub_Marked_CardsInputs */



/**
* | output |
* | --- |
* | "Marked Cards" |
*
* @param {Sanction_Sub_Marked_CardsInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const sanction_sub_marked_cards = /** @type {((inputs?: Sanction_Sub_Marked_CardsInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sanction_Sub_Marked_CardsInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Cartes Marquées")
	if (locale === "es") return /** @type {LocalizedString} */ ("Cartas Marcadas")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Cartas Marcadas")
	if (locale === "it") return /** @type {LocalizedString} */ ("Carte Segnate")
	return /** @type {LocalizedString} */ ("Marked Cards")
});